import { ROLES, type Role } from '../constants/roles';

/**
 * God tabs that only make sense with a focused house (staff ops / live support).
 * Platform tabs (overview, houses, results, knowledge, audit, integrity, billing, config, rates) stay visible.
 */
export const GOD_HOUSE_SCOPED_TABS = ['users', 'tickets'] as const;

const GOD_HOUSE_SCOPED = new Set<string>(GOD_HOUSE_SCOPED_TABS);

/**
 * Drop tabs that cannot be used until a house is selected in the account scope picker.
 */
export function filterTabsByHouseScope(
  role: Role,
  tabs: string[],
  hasHouseScope: boolean,
): string[] {
  if (hasHouseScope) return tabs;
  if (role === ROLES.GOD) {
    return tabs.filter((tab) => !GOD_HOUSE_SCOPED.has(tab));
  }
  if (role === ROLES.SUPPORT_AGENT) {
    // Live queue + house ticket thread need an active house.
    return tabs.filter((tab) => tab !== 'tickets');
  }
  return tabs;
}

export function tabRequiresHouseScope(role: Role, tab: string): boolean {
  if (role === ROLES.GOD) return GOD_HOUSE_SCOPED.has(tab);
  if (role === ROLES.SUPPORT_AGENT) return tab === 'tickets';
  return false;
}
